
import { normalizeDateFormat } from "../MaskSelectorFormUtil";

import {nextgen_measurements} from "../nextGenScan/Util";

import i18n from 'i18next'

export const v2CreateRequestBody = (form_data, dateFormat) => {

    return {
        survey_version: "2",
        patient: {
            patient_code: form_data.patient_code,
            first_name: form_data.first_name,
            last_name: form_data.last_name,
            dob: normalizeDateFormat(form_data.date_of_birth, dateFormat),
            biometrics_consent_accepted: form_data.biometrics_consent_accepted,
        },
        token: form_data.token,
        hme_org_code: form_data.hme_org_code,
        hme_location_code: form_data.hme_location_code,
        fitting_details: {
            nose_width: form_data.nose_width.toString(),
            nose_width_unit: form_data.nose_width_unit,
            face_height: form_data.face_height.toString(),
            face_height_unit: form_data.face_height_unit,
            nose_depth: form_data.nose_depth,
            nose_depth_unit: form_data.nose_depth_unit,

            describes: form_data.best_describes_you,
            refit_reason: form_data.refit_reason,
            mask_type: form_data.mask_type,
            can_breathe_through_nose: form_data.can_breathe_through_nose,
            nose_breath_exception_reason: form_data.nose_breath_exception_reason,
            gender: form_data.gender,
            // common questions
            sleep_position: form_data.sleep_position,
            bed_partner: form_data.bed_partner,
            glasses: form_data.glasses,
            facial_hair: form_data.facial_hair,
            skin_irritation: form_data.skin_irritation,
            facial_creams: form_data.facial_creams,
            claustrophobia: form_data.claustrophobia,
            nasal_dryness: form_data.nasal_dryness,
            mobility: form_data.mobility,
            magnetic: form_data.magnetic,

            mugshot_measurements: form_data.mugshot_measurements,

            language: i18n.language
        },
    };
}

export const v3CreateRequestBody = (form_data, dateFormat) => {

    let request_body = {
        survey_version: "3",
        patient: {
            patient_code: form_data.patient_code,
            first_name: form_data.first_name,
            last_name: form_data.last_name,
            dob: normalizeDateFormat(form_data.date_of_birth, dateFormat),
            biometrics_consent_accepted: form_data.biometrics_consent_accepted,
        },
        token: form_data.token,
        hme_org_code: form_data.hme_org_code,
        hme_location_code: form_data.hme_location_code,
        fitting_details: {
            describes: form_data.best_describes_you,
            refit_reason: form_data.refit_reason,
            mask_type: form_data.mask_type,
            can_breathe_through_nose: form_data.can_breathe_through_nose,
            nose_breath_exception_reason: form_data.nose_breath_exception_reason,
            gender: form_data.gender,
            // common questions
            sleep_position: form_data.sleep_position,
            bed_partner: form_data.bed_partner,
            glasses: form_data.glasses,
            facial_hair: form_data.facial_hair,
            skin_irritation: form_data.skin_irritation,
            facial_creams: form_data.facial_creams,
            claustrophobia: form_data.claustrophobia,
            nasal_dryness: form_data.nasal_dryness,
            mobility: form_data.mobility,
            magnetic: form_data.magnetic,

            mugshot_measurements: form_data.mugshot_measurements,
            language: i18n.language
        },
    };

    if (form_data.mugshot_measurements) {
        request_body.fitting_details.measurements = { };

        for (const element of nextgen_measurements) {
            request_body.fitting_details.measurements[element] = form_data[element];
        }

    } else {
        request_body.fitting_details.measurements = {
            nose_width: form_data.nose_width.toString(),
            nose_width_unit: form_data.nose_width_unit,
            face_height: form_data.face_height.toString(),
            face_height_unit: form_data.face_height_unit,
            nose_depth: form_data.nose_depth.toString(),
            nose_depth_unit: form_data.nose_depth_unit,
        }
    }

    return request_body;
}

export const v2DefaultValues = {

    biometrics_consent_accepted: false,
    first_name: "",
    last_name: "",
    date_of_birth: "",
    nose_width: 1.2,
    nose_width_unit: "in",
    face_height: 4,
    face_height_unit: "in",
    nose_depth: "",
    nose_depth_unit: "mm",
    best_describes_you: "",
    mask_type: "not_asked",
    refit_reason: "not_asked",
    nose_breath_exception_reason: "not_asked",
    gender: "",
    sleep_position: "not_asked",
    bed_partner: "not_asked",
    glasses: "not_asked",
    facial_hair: "not_asked",
    skin_irritation: "not_asked",
    facial_creams: "not_asked",
    claustrophobia: "not_asked",
    nasal_dryness: "not_asked",
    mobility: "not_asked",
    magnetic: "not_asked",
    can_breathe_through_nose: "not_asked",
    mugshot_measurements: false
};